import {
  CompoundEntityRef,
  stringifyEntityRef,
} from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';
import { techDocsMetadataApiRef } from '../api';

export const useExtendedTechDocsMetadata = (
  entityRef: CompoundEntityRef,
  path?: string,
) => {
  const techDocsMetadataApi = useApi(techDocsMetadataApiRef);
  const resolvedPath = path ?? '';
  const { data, isLoading } = useQuery({
    queryKey: [
      'appfolio-techdocs-metadata',
      stringifyEntityRef(entityRef),
      resolvedPath,
    ],
    queryFn: () =>
      techDocsMetadataApi.getTechDocsMetadata(entityRef, resolvedPath),
    refetchOnWindowFocus: false,
  });
  return {
    isLoading,
    links: data?.links,
    tags: data?.tags ?? [],
    description: data?.description,
    title: data?.title,
    parentTitles: data?.parentTitles ?? [],
    relatedPages: data?.relatedPages ?? [],
  };
};
